export const CLASSIFICATION = {
    fair: {
        label: "Fair Renewal",
        note: "Underlying claims support this increase.",
    },
    correction: {
        label: "Pricing Correction",
        note: "This increase corrects pricing that was too low at the start.",
    },
    market: {
        label: "Market Driven",
        note: "Stop-loss and market conditions moved the number.",
    },
    mixed: {
        label: "Mixed",
        note: "Claims, pricing, and market conditions each play a part.",
    },
};

export const RISK_CATEGORIES = [
    ["defend", "Defend & Grow"],
    ["volatile", "Financially Volatile / Strategically Healthy"],
    ["underpriced", "Underpriced at Inception"],
    ["adoption", "Adoption Challenge"],
    ["operational", "Operational Risk"],
    ["competitive", "Competitive Threat"],
];

const YEAR_IN_REVIEW = [
    "Claims performance vs. expectation",
    "Utilization patterns (notable shifts — ER, specialist, high-cost claimants)",
    "Partnership Plan engagement and adoption trend",
    "Operational experience (implementation, service, any escalations)",
].map((line) => `• ${line}`).join("\n");

const AVOIDED = [
    "ER diversion",
    "PCP engagement",
    "Site-of-care optimization",
    "Generic utilization",
    "Specialty Rx management",
    "Navigation interventions",
    "High-performance network steerage",
].map((line) => `• ${line}`).join("\n");

const RENEWAL_OPTIONS = [
    "Status quo",
    "Contribution strategy changes",
    "Funding alternatives (for example, ASO migration)",
    "Plan design changes",
].map((line) => `• ${line}`).join("\n");

const REC_FINANCIAL = ["Present renewal", "Shop stop-loss", "Adjust funding corridor", "Modify contributions", "Evaluate ASO migration"]
    .map((line) => `• ${line}`).join("\n");
const REC_CLINICAL = ["Diabetes management", "MSK initiatives", "Specialty Rx optimization", "Preventive screening"]
    .map((line) => `• ${line}`).join("\n");
const REC_ENGAGEMENT = ["Increase Partnership Plan adoption", "Open enrollment redesign", "Executive education"]
    .map((line) => `• ${line}`).join("\n");
const REC_OPERATIONAL = ["Eligibility cleanup", "Data improvements", "Process improvements"]
    .map((line) => `• ${line}`).join("\n");

export function emptyRenewal() {
    return {
        planYear: "",
        priorCarrier: "",
        priorIncrease: "",
        nextSteps: "",
        switchDriver: "",
        yearInReview: YEAR_IN_REVIEW,
        classification: "fair",
        glanceValue: "",
        glanceAdoption: "",
        glanceClaims: "",
        glanceClinical: "",
        driverMedical: "",
        driverPharmacy: "",
        driverStopLoss: "",
        driverAdmin: "",
        roiIncrease: "",
        roiSavings: "",
        avoided: AVOIDED,
        includeMultiYear: false,
        multiYear: "",
        population: "non-bhcg",
        renewalOptions: RENEWAL_OPTIONS,
        recFinancial: REC_FINANCIAL,
        recClinical: REC_CLINICAL,
        recEngagement: REC_ENGAGEMENT,
        recOperational: REC_OPERATIONAL,
        headed: "Renewal isn't the finish line. Centivo keeps investing in the model your workforce already uses.",
        decisionDate: "",
        enrollmentWindow: "",
        implementation: "",
        includeAppendix: false,
        riskRating: "",
        riskCategory: "",
        clientContext: "",
        benchmarks: [
            { metric: "PCP visits/1,000", centivo: "", milliman: "", regional: "" },
            { metric: "ER visits/1,000", centivo: "", milliman: "", regional: "" },
            { metric: "Hospital admits/1,000", centivo: "", milliman: "", regional: "" },
        ],
        impact: [
            { metric: "Rx PMPM", ppo: "", centivo: "", difference: "" },
            { metric: "Total Cost", ppo: "", centivo: "", difference: "" },
            { metric: "Employer Spend", ppo: "", centivo: "", difference: "" },
        ],
        partnership: [
            { metric: "PMPM", partnership: "", ppo: "" },
            { metric: "Loss ratio", partnership: "", ppo: "" },
            { metric: "ER utilization", partnership: "", ppo: "" },
            { metric: "Preventive compliance", partnership: "", ppo: "" },
            { metric: "Specialist utilization", partnership: "", ppo: "" },
        ],
        rates: [
            { line: "Medical", current: "", proposed: "", change: "" },
            { line: "Stop loss, specific", current: "", proposed: "", change: "" },
            { line: "Stop loss, aggregate", current: "", proposed: "", change: "" },
        ],
    };
}
